module.exports = __webpack_public_path__ + "img/help10.772fbab8.png";